import googleAnalyticsClient from '../common/google_analytics/promotional_material';

document.addEventListener('DOMContentLoaded', () => {
  const indexDiv = document.querySelector('.PromotionalMaterialsIndex') as HTMLElement;
  if (indexDiv == null) {
    return;
  }
  const items = document.querySelectorAll('.PromotionalMaterialsIndex-listItem');
  [].forEach.call(items, item => {
    (item as HTMLElement).addEventListener('click', () => {
      const filename = (item as HTMLElement).dataset.filename || 'unknown';
      googleAnalyticsClient.clickButton(filename);
    });
  });
});
